import _ from 'lodash';
import { history } from 'umi';
import { getPageQuery } from '../utils';

/**
 * Check if the user should be redirected after a logout / refresh token
 * @param {Response} response
 */
export const authRedirect = (response) => {
  if (!(response && !_.isEmpty(response) && _.get(response, 'accessToken'))) {
    return;
  }

  const params = getPageQuery();
  let { redirect } = params;

  if (redirect) {
    const redirectUrlParams = new URL(redirect, window.location.origin);
    const urlParams = new URL(window.location.href);

    if (redirectUrlParams.origin === urlParams.origin) {
      redirect = redirect.substr(urlParams.origin.length);

      if (redirect.match(/^\/.*#/)) {
        redirect = redirect.substr(redirect.indexOf('#') + 1);
      }

      history.replace(redirect);
      return;
    }

    window.location.href = redirect;
    return;
  }

  history.replace('/');
};
